export default __webpack_public_path__ + "static/media/m-nft-desc.3931b6cd.png";